module.exports = __webpack_public_path__ + "static/img/janghyung-labor-management.d17014c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/janghyung-labor-management.jpg
// module id = SrvO
// module chunks = 0